export default {
    header: {
        heading: 'Deadline dates',
        description: 'Plan the feedback cycle timeline: launch, deadline and discussion dates.',
    },
    milestones: {
        projectKickOff: {
            label: 'Project kickoff',
            description: 'Official announcement of the start of the performance management cycle.',
        },
        selfAssessmentLaunch: {
            label: 'Self-assessment launch',
            description: 'Invites employees to start their self-assessment.',
        },
        feedback360Launch: {
            label: '360 feedback launch',
            description: 'Invites peers and employees to provide feedback.',
        },
        managerAssessmentLaunch: {
            label: '{{managerLabelCapitalized}} assessment launch',
            description: 'Invites {{managerPluralLabel}} to start evaluating their employees.',
        },
        managerDeadline: {
            label: '{{managerLabelCapitalized}} deadline',
            description: 'Reminder to the {{managerLabel}} that all evaluations must be completed.',
        },
        discussionEmail: {
            label: 'Discussion email',
            description: 'Invitation to plan and hold the discussion meeting.',
        },
        evaluationCycleClosure: {
            label: 'Feedback cycle closure',
            description: "Confirms the cycle's closure.",
        },
    },
    fields: {
        dateAndTime: 'Date',
        startDateAndTime: 'Start date',
        dueDate: 'Due date',
        clearDate: 'Clear date',
        pickDate: 'Pick a date',
    },
    milestonePosition: 'Milestone {{number}}',
    reminders: {
        label: 'Automatic reminders',
        tooltip:
            'Employees who have already responded to the evaluation will not receive a reminder. Only those who have not responded will be reminded.',
        beforeDeadline: '{{count}} days before the deadline',
        onDeadlineDay: 'On the deadline day',
        beforeStartUnavailable: 'A reminder cannot be sent before the start date.',
    },
    saving: {
        notSaved: 'Your deadlines were not saved. Check the dates and try again.',
        partiallySaved:
            'Only part of your deadlines was saved. Reopen this step to check the dates and reminders before continuing.',
    },
    validation: {
        pastDate: 'This date is in the past.',
        dueBeforeStart: 'The due date must be after the start date.',
        closureNotLast: 'The closure date must be the last date of the cycle.',
        stepBlocked: 'Fix the flagged dates before continuing.',
    },
};
